module.exports = "/_next/static/images/c096bea90ed2ebd3c8ed420c93b7242d-man-looking-up-smiling-xs@3x.jpg";